import React from 'react'
import { useTranslation } from 'react-i18next'
import PatientCopilotMetricWidget from './common/PatientCopilotMetricWidget'
import Sentiment from '../CopilotSettings/icons/Insights/Sentiment'
import { CopilotEngagementTypes } from 'consts/copilotControlConsts'
import useEngagementsWidget from 'components/CopilotControl/components/common/EngagementWidget/useEngagementsWidget'
import { getSentimentEngagementScore } from 'components/CopilotControl/copilotLogic'

const PatientScanningScoreWidget = ({ sentimentScore = null, sentimentReason, isLoading }) => {
  const { t } = useTranslation()

  const { scoreOptions } = useEngagementsWidget({
    engagementType: CopilotEngagementTypes.PatientsSentiment,
    values: {}
  })

  const scoreValue = getSentimentEngagementScore(sentimentScore)
  const scoreOption = scoreOptions[scoreValue]

  return (
    <PatientCopilotMetricWidget
      title={t('pages.patients.patientSidebar.items.copilot.copilotInsights.sentiment.title')}
      titleIcon={<Sentiment />}
      noData={scoreValue === null}
      metricIcon={
        scoreOption?.icon &&
        React.createElement(scoreOption.icon, {
          size: 'small',
          fillColor: scoreOption.fillColor,
          strokeColor: scoreOption.strokeColor
        })
      }
      metricLabel={scoreOption?.label}
      labelColor={scoreOption?.strokeColor}
      tooltip={sentimentReason}
      isLoading={isLoading}
    />
  )
}

export default PatientScanningScoreWidget
